import WINDOW from "../../../../utils/window";
import runReference from "../../../references/run-reference";
import getReference from "../on-step-status/get-reference";
import runOffsetHook from "./run-offset-hook";

/**
 * On offset hooks
 * @param {TimelineMapProps | StepProps | PropertyValueProps} property
 * @param {Boolean} enter
 * @param {Number} overall
 * @param {Boolean} [isStep]
 * @example `on|40%: @move`
 */
const onOffsetHooks = (property, enter, overall, isStep = false) => {
  /**
   * List of offsets with their data
   * @example `0.3 => {'enter-active' => false, 'leave-active' => true, 'hook' => 'on|30%'}`
   */
  const offsets = /** @type {PropertyOffsetHooksProps} */ (
    property.get("offset-hooks")
  );

  for (const [offset, status] of offsets) {
    /** Enter mode */
    if (enter && overall >= offset) {
      /** Do once if not started */
      if (!status.get("enter-active")) {
        runOffsetHook(enter, status, isStep, property);

        status.set("enter-active", true);
        status.set("leave-active", false);
      }
    }

    /** Leave mode */
    if ((!enter && overall <= offset)) {
      /** Do once if not started */
      if (!status.get("leave-active")) {
        runOffsetHook(enter, status, isStep, property);

        status.set("leave-active", true);
        status.set("enter-active", false);
      }
    }
  }
};

export default onOffsetHooks;
